/**
 * Repository search hook
 */

import { useState } from 'react';

import type { GitlabRepository } from '@/lib/types/gitlab';

export const useRepositorySearch = (
  repositories: GitlabRepository[],
): {
  repositorySearchQuery: string;
  setRepositorySearchQuery: (query: string) => void;
  filteredRepositories: GitlabRepository[];
} => {
  const [repositorySearchQuery, setRepositorySearchQuery] = useState('');

  const filteredRepositories = repositories.filter(
    (repo: GitlabRepository) =>
      repo.fullName
        .toLowerCase()
        .includes(repositorySearchQuery.toLowerCase()) ||
      (repo.description
        ?.toLowerCase()
        .includes(repositorySearchQuery.toLowerCase()) ??
        false),
  );

  return {
    repositorySearchQuery,
    setRepositorySearchQuery,
    filteredRepositories,
  };
};
